module.exports = __webpack_public_path__ + "static/media/Manual_Alumno_IPN.fb6d47c4.pdf";